import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, GuidLinkMutations } from './types';
import { getDefaultState } from './state';
import Vue from 'vue';

const _mutations = namespaceHelper.removeNamespace(namespace, GuidLinkMutations);

export default {
  [_mutations.RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [_mutations.SET_ESTIMATE_LINK](state, payload) {
    state.estimateLink = payload || {};
  },
  [_mutations.SET_ESTIMATE_LINK_LOOKUPS](state, payload) {
    state.estimateLinkLookups = payload;
  },
  [_mutations.SET_OPERATION_STATUS](state, payload) {
    state.estimateLink.jobs.find(
      j => j.jobId == payload.job.jobId && j.operationId == payload.job.operationId
    ).jobOperationStatusId = payload.jobOperationStatusId;
  },
  [_mutations.SET_ESTIMATE_LINK_PROP](state, { key, value }) {
    Vue.set(state.estimateLink, key, value);
  },
  [_mutations.SET_UNIT](state, payload) {
    state.unit = payload || {};
  },
  [_mutations.SET_PAYMENT_LINK](state, payload) {
    state.paymentLink = payload;
  }
};
